import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ChevronUp } from "lucide-react";
import { ArrowUp } from "lucide-react"; // ✅ correct icon

const ScrollTopButton = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShow(window.scrollY > 200); // show after scrolling 200px
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  if (!show) return null;

  return (
    <motion.button
      onClick={scrollToTop}
      className="fixed bottom-10 right-5 bg-blue-700 hover:bg-primary-700 text-white p-3 rounded-full shadow-lg z-50"
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
    >
     <ArrowUp className="h-6 w-6" />
    </motion.button>
  );
};

export default ScrollTopButton;
